const makeGetRequest = async (apiClient, path, options) => {
    const params = {};
    if (options) {
        if (options.page) {
            params.page = options.page;
        }
        if (options.limit) {
            params.limit = options.limit;
        }
    }
    return await apiClient.get(path, {
        params,
        signal: options?.signal,
    });
};
export const fetchReportData = async ({ apiClient, entityId, options, }) => {
    return await makeGetRequest(apiClient, `/v1/entities/${entityId}/training`, options);
};
export const fetchStudyData = async ({ apiClient, entityId, options, }) => {
    return await makeGetRequest(apiClient, `/v1/entities/${entityId}/studies`, options);
};
export const bulkFetchPages = async ({ exec, check, abortSignal, }) => {
    let page = 1;
    const LIMIT = 100; // MOM API maximum limit
    const results = [];
    while (true) {
        const result = await exec({ page, limit: LIMIT, signal: abortSignal });
        const response = result.data;
        if (Array.isArray(response.data)) {
            results.push(...response.data);
        }
        else {
            // If there is only one result, add it to the results array
            results.push(response.data);
        }
        if (check(result, page, results)) {
            break;
        }
        page++;
    }
    return results;
};
